import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../../shared/services/school.service";
import { SchoolselectorService } from "../../../../../schoolselector/schoolselectorservice.service";
import { StaffSimpleInsertRequest } from "../../../../services/StaffSimpleInsertRequest";
import { StringRequest } from "../../../../services/StringRequest";
import { SysAdminService } from "../../../../services/sysadmin.service";

@Component({
	selector: "app-user-admin-add-staff",
	templateUrl: "./user-admin-add-staff.component.html",
	styleUrls: ["./user-admin-add-staff.component.css"],
})
export class UserAdminAddStaffComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private schoolService: SchoolService,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		var SchoolIDFromMain = this.dialogConfig.data.SchoolID;

		this.loadSchools(SchoolIDFromMain);
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	SchoolLoading: boolean = false;
	lstSchool: any = [];
	School: any;

	FirstName: string = "";
	LastName: string = "";
	StaffID: string = "";

	Processing: boolean = false;

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////

	loadSchools(SchoolIDFromMain) {
		var result = this.schoolService.loadSchoolListWithOptions("5397160d-77d9-4422-9d64-8463ea7eba22", -1);

		result.subscribe(
			(response: any) => {
				this.lstSchool = response;

				for (var z = 0; z < this.lstSchool.length; z++) {
					var next = this.lstSchool[z];

					if (next.SchoolID == SchoolIDFromMain) {
						this.School = next;
						break;
					}
				}

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//
		if (this.FirstName == "") {
			this.errorMessage = "Enter a First Name";
			return;
		}
		if (this.LastName == "") {
			this.errorMessage = "Enter a Last Name";
			return;
		}
		if (this.StaffID == "") {
			this.errorMessage = "Enter a Staff ID";
			return;
		}

		this.CheckStaffID();
	}

	CheckStaffID() {
		this.Processing = true;

		var parms: StringRequest = {
			str: this.StaffID,
		};

		var result = this.sysAdminService.StaffIDExists(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					if (response.Exists == true) {
						this.errorMessage = "Staff ID already exists";
						return;
					} else {
						this.FinishAddStaff();
					}
				} else {
					this.errorMessage = "Error checking Staff ID";
					return;
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	FinishAddStaff() {
		this.Processing = true;

		var parms: StaffSimpleInsertRequest = {
			SchoolID: this.School.SchoolID,
			FirstName: this.FirstName,
			LastName: this.LastName,
			StaffID: this.StaffID,
		};

		var result = this.sysAdminService.StaffSimpleInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "useraddstaff",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Staff was created successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(response.PersonID);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "useraddstaff",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the staff member: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////
	onSchoolChange(val) {
		this.School = val;
	}
	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////
	IsLoading() {
		return this.SchoolLoading == true || this.Processing == true;
	}
	//////////////////////////////////////////////////////////////
}
